import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
@Component({
    selector: 'text-editor',
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    templateUrl: './text-editor.component.html'
})
export class TextEditorComponent {
  // //#region properties
  // editorConfig = {};
  // Editor = ClassicEditor;
  // @Input() control: FormControl | any;
  // @Input() model: any;
  // @Input() isShowToolbar: boolean = true;
  // @Output() modelChange = new EventEmitter<any>();
  // //#endregion
  // ngOnInit(): void {
  //   this.configEditor();
  // }
  // configEditor() {
  //   try {
  //     const isLtr: boolean =
  //       document.getElementsByTagName('html')[0]?.getAttribute('dir') == 'ltr'
  //         ? true
  //         : false;
  //     this.editorConfig = {
  //       dir: isLtr ? 'ltr' : 'rtl',
  //       language: isLtr ? 'en' : 'fa',
  //       inline: true,
  //       enter: 'p',
  //       toolbar: this.isShowToolbar
  //         ? [
  //             'undo',
  //             'redo',
  //             '|',
  //             'heading',
  //             '|',
  //             'fontfamily',
  //             'fontsize',
  //             'fontColor',
  //             'fontBackgroundColor',
  //             '|',
  //             'bold',
  //             'italic',
  //             'strikethrough',
  //             'subscript',
  //             'superscript',
  //             'code',
  //             '|',
  //             'link',
  //             'uploadImage',
  //             'blockQuote',
  //             'codeBlock',
  //             '|',
  //             'bulletedList',
  //             'numberedList',
  //             'todoList',
  //             'outdent',
  //             'indent',
  //           ]
  //         : '',
  //       uploader: {
  //         insertImageAsBase64URI: false,
  //       },
  //       defaultMode: 0,
  //     };
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }
  // emit() {
  //   this.modelChange.emit(this.model);
  // }
}
